import VueChartJS from 'vue-chartjs';
import ChartJSDatalabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';

Chart.plugins.unregister(ChartJSDatalabels);
Chart.plugins.register(ChartJSDatalabels);

export default {
    extends: VueChartJS.Line,
    props: {
        data: {
            type: Object,
            default: () =>({})
        },
        page: Number,
        url:  {
            type: String,
            default: ''
        },
        tooltipaftertitle: {
            type: Array,
            default: () => [],
        },
        totalValue:  {
            type: String,
            default: ''
        },
        disable: {
            type: Boolean,
            default: false,
        },
        showValue: {
            type: Boolean,
            default: false,
        },
        showlegend: {
            type: Boolean,
            default: true
        },
        legendPosition: {
            type: String,
            default: 'bottom'
        },
        toggleLegend: {
            type: Boolean,
            default: true
        },
    },

    computed: {
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 20,  // Tambah ruang di atas chart
                        bottom: 10, // Tambah ruang di bawah chart
                        right: 20,
                    }
                },
                legend: {
                    display: this.showlegend,
                    position: this.legendPosition,
                    labels: {
                        font: {
                            size: 8
                        },
                        usePointStyle: false,
                    },
                    onHover: (event) => {
                        this.$data._chart.canvas.style.cursor = "pointer";
                    },
                    onLeave: (event) => {
                        this.$data._chart.canvas.style.cursor = "default";
                    }
                },
                title: {
                    display: false,
                    text: 'Penerimaan'
                },
                tooltips: {
                    enabled: true,
                    intersect: false,
                    mode: 'index',
                    callbacks: {
                        label: function (tooltipItem, data) {
                            let dstLabel = data.datasets[tooltipItem.datasetIndex].label;
                            return dstLabel + ': ' + tooltipItem.yLabel.toLocaleString('en-US', { maximumFractionDigits: 2 });
                        },
                    },
                },
                scales: {
                    yAxes: [{
                        gridLines: {
                            offsetGridLines: false,
                            tickMarkLength: false,
                            drawTicks: false,
                            zeroLineColor:'transparent',
                            display:true,
                            borderDash:[10],
                            color:'rgba(255,0,0,.125)',
                        },
                        ticks: {
                            beginAtZero: true,
                            display:true,
                            padding:10,
                            callback: function (value) {
                                if (value >= 1000000) return (value / 1000000).toLocaleString('en-US') + ' J';
                                if (value >= 100000) return (value / 1000).toLocaleString('en-US') + ' K';
                                //if (value <= -1000000000) return (value / 1000000000).toLocaleString('en-US') + ' M';
                                if (value <= -1000000) return (value / 1000000).toLocaleString('en-US') + ' J';
                                if (value <= -100000) return (value / 1000).toLocaleString('en-US') + ' K';
                                return value;
                            },
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            offsetGridLines: false,
                            tickMarkLength: false,
                            drawTicks: false,
                            zeroLineColor:'transparent',
                            display:true,
                            borderDash:[10],
                            color:'rgba(0,0,255,.125)',
                        },
                        ticks: {
                            beginAtZero: true,
                            display:true,
                            padding: 10
                        }
                    }]
                },
                plugins: {
                    datalabels: {
                        display: this.showValue,
                        align: "top",
                        anchor: "end",
                        font: {
                            size: 10
                        },
                        offset:4, // Menambah jarak dari titik
                        padding: {
                            top: 4, // Memberi ruang ekstra agar tidak kepotong
                            bottom: 4
                        },
                        clip: false, // Agar label tetap terlihat meskipun di batas chart
                        formatter: (value) => {
                            return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value);
                        },
                        color: "#000"
                    }
                }
            };
        }
    },

    methods: {
        redraw() {
            this.renderChart(this.data, this.chartOptions);
        },
        checkAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = false;
            });
        },
        uncheckAllLegend() {
            const chart = this.$data._chart;
            chart.data.datasets.forEach(dataset => {
                dataset.hidden = true;
            });
        }
    },

    mounted() {
        this.redraw();
    },

    watch: {
        data() {
            this.redraw();
        },
        showValue() {
            this.redraw();
        },
        toggleLegend(newVal) {
            if (newVal) {
                this.checkAllLegend();
            } else {
                this.uncheckAllLegend();
            }
        }
    }
};
